import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M50.0001 34.8621H50.0006C52.0958 34.8621 54.0635 35.6844 55.5411 37.1776L76.7965 58.6663C78.2725 60.1585 78.2593 62.5643 76.7672 64.0403C75.2755 65.5154 72.8692 65.5027 71.3931 64.011L50.1378 42.5223C50.1099 42.494 50.0684 42.4617 50.0001 42.4617C49.9312 42.4617 49.8897 42.4949 49.8614 42.5233L28.6065 64.011C27.1299 65.5027 24.7237 65.5159 23.2335 64.0403C21.7413 62.5643 21.7276 60.1585 23.2042 58.6663L44.459 37.1785C45.9366 35.6844 47.9044 34.8621 50.0001 34.8621Z'

const IconCaretUp: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretUp
